import React from "react";

const regex = /([0-9\W_]+)/g; // Matches sequences of digits, special characters, or underscores

const StyledTextWithNumbers = ({ text }) => 
	text.split(regex).map((part, index) =>
		regex.test(part) ? (
			<span key={index} className="font-prata smaller-text">
				{part}
			</span>
		) : (
			part
		)
	);


const UppercaseHighlightText = ({ text, uppercaseText }) => {
	let firstWordHandled = false;

	return text.split(regex).map((part) => {

		if (uppercaseText.includes(part.toUpperCase())) {
			return part.toUpperCase();
		}
		if (!firstWordHandled) {
			firstWordHandled = true;
			const lower = part.toLowerCase();
			return lower.charAt(0).toUpperCase() + lower.slice(1);
		}
		return part.toLowerCase();
	});
};


export { StyledTextWithNumbers, UppercaseHighlightText };
